import React from "react";
var __jsx = React.createElement;
import { CDN_LINK, SELECTED_ENV, SHOW_DEBUG_INFO } from "@globalConfig";
import stl from "./Header.module.css";
import { useTranslation } from "@i18n";
import loadable from "@loadable/component";
import useIsMobile from "@hooks/useIsMobile";
import useIsBrowser from "@hooks/useIsBrowser";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import useHelpers from "@hooks/useHelpers";
import { dispatchSideMenuToggle as toggleMenu } from "@/_LayoutsRelated/layoutHooks/useSideMenuController";
import useScrollDirection from "@hooks/useScrollDirection";
import SyarahLogo from "@/components/SyarahLogo/SyarahLogo";
import { useCart } from "@/common/Contexts/CartContext";
import { Icon } from "@syarahtech/ui";
var fallback = /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
var UnbxdTextSearch = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdTextSearch";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdTextSearch" */"../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
    }
    return eval('require.resolve')("../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
  }
}, fallback);
var getEnvironmentColor = function getEnvironmentColor() {
  var env = SELECTED_ENV.toLowerCase();
  switch (env) {
    case 'prod':
    case 'production':
      return 'inherit';
    case 'qa':
      return '#DC2626';
    // red-600
    case 'preprod':
      return '#D97706';
    // amber-600
    case 'dev':
      return '#EA580C';
    // orange-600
    default:
      return '#16A34A';
    // green-600
  }
};
var CartBadgeIcon = function CartBadgeIcon(_ref) {
  var href = _ref.href,
    count = _ref.count;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: "relative flex items-center justify-center w-10  no-underline",
    "aria-label": "cart",
    onClick: function onClick(e) {
      if (__IS_CSR__ && window.location.pathname === new URL(href, window.location.origin).pathname) {
        e.preventDefault();
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--shopping-cart-outline-rounded",
    className: "text-primary-old",
    width: 6,
    height: 6
  }), count > 0 && /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-0.5 -start-0.5 min-w-[17px] h-[17px] px-[3px] flex items-center justify-center rounded-full bg-[#EC6234] text-white text-[9px] font-bold leading-none"
  }, count > 99 ? "99+" : count));
};
var Header = function Header(props) {
  var _useTranslation = useTranslation(["web_header", "web_common"]),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var isBrowser = useIsBrowser();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useScrollDirection = useScrollDirection(),
    isScrollingDown = _useScrollDirection.isScrollingDown;
  var _useCart = useCart(),
    totalItems = _useCart.totalItems;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.custommobileHeaderFragmentOnly ? props.custommobileHeader : props.custommobileHeader && /*#__PURE__*/React.createElement("div", {
    className: props.custommobileHeader ? ["m-show", stl.custommobileHeader].join(" ") : undefined
  }, props.custommobileHeader), /*#__PURE__*/React.createElement("header", {
    className: [stl.siteHeader, props.revampedSearch ? stl.revampedHeader : "", props.className ? props.className : "", props.hideHeaderOnmobile ? "m-hide" : undefined, props.straightHeader ? stl.straightHeader : "", "transition duration-1000", props !== null && props !== void 0 && props.hideHeadOnScroll && isScrollingDown && isMobile ? "translate-y-[-100%]" : undefined].join(" ")
  }, SHOW_DEBUG_INFO && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: getEnvironmentColor(),
      color: 'white',
      padding: '16px 20px',
      fontSize: '12px',
      fontWeight: 'bold',
      borderRadius: '0 0 4px 4px',
      zIndex: 1000
    }
  }, SELECTED_ENV.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    id: "desktopHeader",
    className: ["container", stl.innerHdr, props.mobileHasTitle ? "mobHasTitleContainer" : ""].join(" ")
  }, !props.tracking ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: [props.showSearchBar ? "SearchHEader" : undefined, stl.backFlex].join(" ")
  }, props.mobileHasBack && isBrowser && history.state != null && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      document.querySelector(".backtolisting") != null ? window.location.href = document.querySelector(".backtolisting").querySelector("a").getAttribute("href") : history.back();
    },
    className: ["m-show", stl.mobileBackBlueArr].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mobileBackBlueArr.svg",
    alt: "back"
  })), /*#__PURE__*/React.createElement("a", {
    className: [props.logoNotClickable ? stl.disableLink : undefined, props.mobileNoLogo ? "m-hide" : ""].join(" "),
    href: createUrl("/"),
    "aria-label": "Syarah home"
  }, /*#__PURE__*/React.createElement(SyarahLogo, {
    width: 83,
    height: 38,
    className: [stl.logoSizeRev, "hasEvents"].join(" "),
    alt: "syarah logo icon",
    id: "home-logo"
  }))), /*#__PURE__*/React.createElement("p", {
    className: ["m-show", stl.mobHasTitle].join(" ")
  }, props.mobileHasTitle)) : /*#__PURE__*/React.createElement("a", {
    href: createUrl('/tracking-landing'),
    className: stl.trackingLink
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/trackinh-header.svg",
    alt: "Tracking icon"
  }), t("back_track_car", {
    ns: "web_header"
  })), props.showSearchBar && !isMobile && /*#__PURE__*/React.createElement(UnbxdTextSearch, {
    setPage: props.setUnbxdPage,
    referral_location: "listing"
  }), !props.hideSideMenue && /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    className: [stl.lastLiRev, "flex items-center gap-2"].join(" ")
  }, (props === null || props === void 0 ? void 0 : props.showCartIcon) && !isMobile && totalItems > 0 && /*#__PURE__*/React.createElement(CartBadgeIcon, {
    href: createUrl("/site/cart"),
    count: totalItems
  }), !props.hideBurgerMenu && /*#__PURE__*/React.createElement(React.Fragment, null, props.burgrMenuisCncl && isMobile ? /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return window.history.back();
    },
    className: "cnclHDR"
  }, t("cancel", {
    ns: "web_common"
  })) : !props.tracking ? /*#__PURE__*/React.createElement("span", {
    onClick: toggleMenu,
    className: "sideMenuToggle m-hide cursor-pointer",
    id: "side-menu-toggle"
  }, !isMobile && /*#__PURE__*/React.createElement(ProgressiveImage, {
    id: "burger-menu",
    "data-id": "burgerMenu",
    fetchpriority: "low",
    className: [stl.MenuIcnSizeRev, "hasEvents"].join(" "),
    src: CDN_LINK + "/assets/images/menuToggle.svg",
    width: 24,
    height: 16,
    alt: "T"
  })) : null))), isMobile && ((props === null || props === void 0 ? void 0 : props.showUserAvatar) || (props === null || props === void 0 ? void 0 : props.showCartIcon)) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, (props === null || props === void 0 ? void 0 : props.showCartIcon) && totalItems > 0 && /*#__PURE__*/React.createElement(CartBadgeIcon, {
    href: createUrl("/site/cart"),
    count: totalItems
  }), (props === null || props === void 0 ? void 0 : props.showUserAvatar) && /*#__PURE__*/React.createElement("a", {
    href: createUrl("/user/account"),
    className: "flex items-center justify-center w-9 h-9"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/account.svg",
    width: "24px",
    height: "24px",
    alt: "account"
  }))))));
};
export default Header;